export default "__VITE_ASSET__CXSddG75__"